const STUN = [
  { urls: [
    'stun:stun.l.google.com:19302',
    'stun:stun1.l.google.com:19302',
    'stun:stun2.l.google.com:19302',
    'stun:stun.cloudflare.com:3478'
  ] }
]

let iceServers = STUN

export const getIceConfig = () => ({
  iceServers,
  iceCandidatePoolSize: 8
})

export const packSdp = (desc) => {
  if (!desc) return null
  return { type: desc.type, sdp: desc.sdp }
}

export const addIceSafe = async (pc, candidate) => {
  if (!pc || !candidate) return
  try {
    await pc.addIceCandidate(new RTCIceCandidate(candidate))
  } catch (_) {}
}

export const packIce = (candidate) => {
  if (!candidate) return null
  if (typeof candidate.toJSON === 'function') return candidate.toJSON()
  return {
    candidate: candidate.candidate,
    sdpMid: candidate.sdpMid,
    sdpMLineIndex: candidate.sdpMLineIndex,
    usernameFragment: candidate.usernameFragment
  }
}

export const loadIceConfig = async () => {
  try {
    const res = await fetch('/api/ice')
    const type = res.headers.get('content-type') || ''
    if (!res.ok || !type.includes('json')) return getIceConfig()
    const data = await res.json()
    if (Array.isArray(data.iceServers) && data.iceServers.length) iceServers = data.iceServers
  } catch (err) {}
  return getIceConfig()
}
